import { createSlice } from "@reduxjs/toolkit";

let url = window.location.href;
let lastSlashIndex = url.lastIndexOf("/");

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  date.setDate(date.getDate() - 1); // Substracting 1 day to the date
  return date;
} 

function returnEndDate(months) {
  const FromDate = new Date();
  const endDate = addMonths(FromDate,parseInt(months));
  // console.log("Lohith:Payment:handleCalculate: endDate = ", endDate);
  return returnDate(endDate);
}

function returnDueDate(noOfDays) {
  var myCurrentDate=new Date();
  var myFutureDate=new Date(myCurrentDate);
  myFutureDate.setDate(myFutureDate.getDate() + noOfDays);
  return returnDate(myFutureDate);
}

function returnDate(date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) {
      dd = '0' + dd;
  }
  if (mm < 10) {
      mm = '0' + mm;
  }
  return dd + '-' + mm + '-' + yyyy;
}

const initialState = {
  activePage: url.substr(lastSlashIndex + 1),
  isSplashScreen: false,
  isAuthenticated: false,
  isSignedIn: false,
  isForgotPassword: false,
  user: [],
  productDetails: {},
  amountPayable: 0,
  mediaRecorder: {},
  recordedBlobs: [],
  isWebCamOn: false,
  isVideoRecorderStarted: false,
  isVideoRecorded: false,
  paymentMode: "",
  orderId: null,
  invoice: {
    "id": "5df3180a09ea16dc4b95f910",
    "invoice_no": "",
    // "balance": "$2,283.74",

    "company_name": "aiRender® Technology Private Limited",
    "company_email": "airender@airender.in",
    "company_phone": "+91-8884780926",
    "company_address": "H-005, Vijetha Elysium, Hagadur Road, Whitefield, Bangalore, Karnataka, India. PIN 560066",
    "company_gst_in": "GSTIN: 29AATCA2217R1ZX",
  
    "account_name": "Airender Technology Private Limited",
    "account_no": "258884780926",
    "bank": "IndusInd Bank",
    "branch": "Vijayanagar, Bengaluru, Karnataka",
    "IFSC": "INDB0001419",

    // "cust_name": "Lohith P",
    // "cust_email": "lohith.airender@gmail.com",
    // "cust_phone": "+91-8147776859",
    // "cust_address": "103/7, Old Madras Road, Muniyappa compound, Halsur, Bangalore, Karnataka, India. PIN 560008",
    "cust_gst_in": "GSTIN: 0",

    // "trans_date": "30-09-2022",
    // "from_date": "30-09-2022",
    // "to_date": "28-10-2022",
    // "due_date": "02-10-2022",

    "trans_date": new Date(),
    "from_date": returnDate(new Date()),
    "to_date": "",
    "due_date": returnDueDate(2),
    
    "items": []
  },
  subscriptions : {},
  receivedBillNumber : false,
  all3DRecords: {}
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    handle_activePage: (state, actions) => {
      // console.log("Redux:reducer:handle_activePage = ", actions.payload);
      state.activePage = actions.payload;
    },
    handle_SplashScreen: (state, actions) => {
      state.isSplashScreen = actions.payload;
    },
    handle_Authenticate: (state, actions) => {
      state.isAuthenticated = actions.payload;
    },
    handle_signedIn: (state, actions) => {
      state.isSignedIn = actions.payload;
    },
    handle_forgotPassword: (state, actions) => {
      state.isForgotPassword = actions.payload;
    },
    handle_auth_user: (state, actions) => {
      // console.log("Redux:reducer:handle_auth_user = ", actions.payload);
      const cust_details = actions.payload;
      state.user = cust_details;
      state.invoice = {
        ...state.invoice,
        "cust_name": cust_details.fullName ? cust_details.fullName : cust_details.name,
        "cust_email": cust_details.email,
        "cust_phone": cust_details.mobile,
        "cust_address": cust_details.address,
      }
    },
    handle_product_details: (state, actions) => {
      // console.log("lohith:Redux:reducer:handle_product_details:actions.payload = ",actions.payload);
      state.productDetails = actions.payload;
      var items = [];
      var totalAmount = 0;
      Object.keys(state.productDetails).map(function(key) {
        items.push(state.productDetails[key])
        totalAmount = totalAmount + state.productDetails[key].total;
      })
      state.amountPayable = totalAmount;
      // console.log("lohith:Redux:reducer:handle_product_details:actions.payload:totalAmount = ",totalAmount);
      state.invoice.items = items;
      // console.log("lohith:Redux:reducer:handle_product_details:actions.payload:items = ",items);


      // Removing the specified element by value from the array
      // var spliced = [];
      // if (state.productDetails.length > 0) {
      //   for (var i = 0; i < state.productDetails.length; i++) {
      //     if (state.productDetails[i].name === actions.payload.name) {
      //       spliced = [state.productDetails.splice(i, 1)];
      //       console.log("lohith:Redux:reducer:handle_product_details:spliced = ",spliced);
      //       break;
      //     }
      //   }
      //   state.productDetails = [...state.productDetails,actions.payload];
      // } else {
      //   state.productDetails = [actions.payload];
      // }
      // var gTotal = 0;
      // for (var i = 0; i < state.productDetails.length; i++) {
      //   gTotal = gTotal + state.productDetails[i].total;
      // }
      // state.productDetails.grandTotal = gTotal;
      // state.productDetails.amountPayable = gTotal + ((gTotal / 100) * 18);
      // console.log("lohith:Redux:reducer:handle_product_details:productDetails = ",state.productDetails);
      
      // console.log("lohith:Redux:reducer:handle_product_details:state.invoice = ",state);
      // state.invoice.items = state.productDetails
      // console.log("lohith:Redux:reducer:handle_product_details:state.invoice = ",state.invoice);
      // state.productDetails = actions.payload;
    },
    handle_Clear_Cart: (state, actions) => {
      state.productDetails = {}
    },
    handle_amountPayable: (state, actions) => {
      state.amountPayable = actions.payload;
    },
    handle_mediaRecorder: (state, actions) => {
      state.mediaRecorder = new MediaRecorder(window.stream, actions.payload);
    },
    handle_recordedBlobs: (state, actions) => {
      // console.log("Redux:reducer:handle_recordedBlobs = ", actions.payload);
      state.recordedBlobs = actions.payload;
    },
    handle_webCam: (state, actions) => {
      state.isWebCamOn = actions.payload;
    },
    handle_videoRecorder: (state, actions) => {
      state.isVideoRecorderStarted = actions.payload;
    },
    handle_videoRecordStatus: (state, actions) => {
      state.isVideoRecorded = actions.payload;
    },
    handle_orderId: (state, actions) => {
      state.orderId = actions.payload;
    },
    handle_paymentMode: (state, actions) => {
      state.paymentMode = actions.payload;
    },
    handle_endDate: (state, actions) => {
      // console.log("Redux:reducer:handle_transaction_dates = ", actions.payload);
      state.invoice = {
        ...state.invoice,
        "to_date": actions.payload,
      }
    },
    handle_billNumber: (state, actions) => {
      // console.log("Redux:reducer:handle_billNumber = ", actions.payload);
      if (!state.receivedBillNumber) {
        state.invoice.invoice_no = actions.payload;
        state.receivedBillNumber = true;
      }
    },
    handle_subscriptions: (state, actions) => {
      // console.log("Redux:reducer:handle_subscriptions = ", actions.payload);
      state.subscriptions = actions.payload;
    },
    handle_3DRecords: (state, actions) => {
      console.log("Redux:reducer:handle_3DRecords = ", actions.payload);
      state.all3DRecords = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  handle_activePage,
  handle_SplashScreen,
  handle_Authenticate,
  handle_auth_user,
  handle_signedIn,
  handle_forgotPassword,
  handle_product_details,
  handle_Clear_Cart,
  handle_mediaRecorder,
  handle_recordedBlobs,
  handle_webCam,
  handle_videoRecorder,
  handle_videoRecordStatus,
  handle_orderId,
  handle_paymentMode,
  handle_endDate,
  handle_billNumber,
  handle_subscriptions,
  handle_3DRecords,
} = authSlice.actions;

export default authSlice.reducer;
